import { useState } from "react";
import CopyCode from "../../CopyCode/CopyCode";

const TabPanel = () => {
  const [tab1, setTab1] = useState(0);
  const [tab2, setTab2] = useState(0);

  return (
    <div className="flex flex-col gap-y-10 p-6">
      {/* TAB PANELS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-white mb-6">Tab Panels</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Basic Tabs</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600">
              <div className="flex gap-2 border-b border-slate-600 mb-3">
                {["Tab 1", "Tab 2", "Tab 3"].map((t, i) => (
                  <button key={i} onClick={() => setTab1(i)} className={`px-3 py-2 text-sm font-medium transition-colors ${tab1 === i ? "text-amber-400 border-b-2 border-amber-400" : "text-slate-400 hover:text-slate-300"}`}>{t}</button>
                ))}
              </div>
              <p className="text-xs text-slate-400">Content for Tab {tab1 + 1}</p>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`const [tab, setTab] = useState(0);

<div className="flex gap-2 border-b">
  {tabs.map((t, i) => (
    <button key={i} onClick={() => setTab(i)} className={tab === i ? "border-b-2 border-amber-400 text-amber-400" : "text-slate-400"}>
      {t}
    </button>
  ))}
</div>
<div>{content[tab]}</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Styled Tabs</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600">
              <div className="flex gap-1 mb-3 bg-slate-800 p-1 rounded">
                {["Active", "Inactive", "Disabled"].map((t, i) => (
                  <button key={i} className={`flex-1 px-2 py-1 rounded text-xs font-medium transition-colors ${i === 0 ? "bg-amber-600 text-white" : "text-slate-400"}`}>{t}</button>
                ))}
              </div>
              <p className="text-xs text-slate-400">Tab content area</p>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="flex gap-1 bg-slate-800 p-1 rounded">
  {tabs.map((t, i) => (
    <button key={i} className={i === active ? "bg-amber-600 text-white" : "bg-transparent text-slate-400"} onClick={() => setActive(i)}>
      {t}
    </button>
  ))}
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Vertical Tabs</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600">
              <div className="flex gap-2">
                <div className="flex flex-col gap-1 border-r border-slate-600 pr-2">
                  {["Left 1", "Left 2", "Left 3"].map((t, i) => (
                    <button key={i} className="text-left text-xs text-slate-400 hover:text-slate-200 px-2 py-1">{t}</button>
                  ))}
                </div>
                <p className="text-xs text-slate-400">Content</p>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="flex">
  <div className="flex flex-col border-r">
    {tabs.map((t, i) => (
      <button key={i} className={i === active ? "bg-amber-600" : "bg-slate-700"}>
        {t}
      </button>
    ))}
  </div>
  <div className="flex-1">{content}</div>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Icon Tabs</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600">
              <div className="flex gap-2 border-b border-slate-600 pb-2">
                {[{icon: "??", label: "Home"}, {icon: "?", label: "Settings"}, {icon: "?", label: "Info"}].map((t, i) => (
                  <button key={i} className="flex items-center gap-1 text-xs text-slate-400 hover:text-amber-400">{t.icon} {t.label}</button>
                ))}
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`{tabs.map((t, i) => (
  <button key={i} className="flex items-center gap-2">
    <span>{t.icon}</span>
    <span>{t.label}</span>
  </button>
))}`} />
          </div>
        </div>
      </div>

      {/* ADVANCED TABS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-amber-400 mb-6">Advanced Variants</h2>
        <div className="grid grid-cols-1 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Scrollable Tabs</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600">
              <div className="overflow-x-auto flex gap-2 border-b border-slate-600 pb-2">
                {[...Array(8)].map((_, i) => <button key={i} className="px-3 py-1 text-xs text-slate-400 whitespace-nowrap hover:text-amber-400">Tab {i + 1}</button>)}
              </div>
              <p className="text-xs text-slate-400 mt-3">Scroll horizontally to see all tabs</p>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="overflow-x-auto flex gap-2 border-b">
  {tabs.map((t, i) => (
    <button key={i} className="px-3 py-2 whitespace-nowrap">
      {t}
    </button>
  ))}
</div>`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TabPanel;


